import { Box } from '@chakra-ui/react';

interface SelectableRadioProps {
  isSelected: boolean;
}

export const SelectableRadio = ({ isSelected }: SelectableRadioProps) => {
  return (
    <Box
      boxSize={5}
      borderRadius="full"
      borderWidth="1px"
      borderColor={isSelected ? 'primary.500' : 'neutral.300'}
      bg={isSelected ? 'primary.500' : 'white'}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      {isSelected && <Box boxSize={2} borderRadius="full" bg="white" />}
    </Box>
  );
};
